<app-form>
  <app-login-form [loginFormModel]="loginFormModel"></app-login-form>
</app-form>